import { Config, PerEnvironmentConfigs } from '@/config/config'
// TODO: adjust for this and future brands
import { logo } from '@/config/assets/vanilla'
import '@vgw/multibrand-fe-styles/css/themes/chocolate.css'

const BRAND_NAME = 'Chocolate'
const BRAND_CODE: string = 'CHO'

const devConfig: Config = {
  name: `${BRAND_NAME}`,
  code: `${BRAND_CODE}`,
  keycloak: {
    url: 'https://auth.dev-vgw-vanilla.com/realms',
    realm: 'VAN',
    clientId: 'vanilla-spa',
  },

  gamGalleryViewApiUrl: 'https://api.gap-dev.vgwgames.com/view',
  gamGalleryUserPreferencesApiUrl:
    'https://api.gap-dev.vgwgames.com/preferences',
  gamGalleryTickersApiUrl: 'https://api.gap-dev.vgwgames.com/tickers',
  pamPlayerTokensApiUrl: 'https://pam.dev-vgw-vanilla.com/player-tokens',
  pamStoreApiUrl: 'https://pam.dev-vgw-vanilla.com/store/v1',
  pamAmoeApiUrl: 'https://pam.dev-vgw-vanilla.com/pay-hub',
  pamAccountApiUrl: 'https://pam.dev-vgw-vanilla.com/player-identity',
  pamKycApiUrl: 'https://pam.dev-vgw-vanilla.com//kyc',
  pamPlayerTokensHistoryApiUrl:
    'https://pam.dev-vgw-vanilla.com/player-tokens-history',
  payPurchasesApiUrl: 'https://payments.dev.vgwgroup.net',
  payRedemptionsApiUrl: 'https://payments.dev.vgwgroup.net',
  pamRsgApiUrl: 'https://pam.dev-vgw-vanilla.com',
  pamRedemptionApiUrl: 'https://pam.dev-vgw-vanilla.com/pay-hub',
  gamPeriodicBonusServiceApiUrl: 'https://api.gap-dev.vgwgames.com',
  pamPurchaseLimitsApiUrl: 'https://pam.dev-vgw-vanilla.com',
  gamGameRoundInfoApiUrl: 'https://api.gap-dev.vgwgames.com',
  gamQuestsPlayerApiUrl: 'https://api.gap-dev.vgwgames.com',
  amplitude: {
    apiKey: 'b19233b5ca81aca0f4c9e511bcfa9c3a',
    loggingEnabled: false,
    region: 'EU',
    deploymentKey: 'client-Vh3CNSskB5ucSVJajq8F1T7vVR9GOVEG',
  },
  helpCenterUrl:
    'https://vgw--develop.sandbox.my.site.com/HelpLWR/contact-form',
  heroBannerType: {
    lobby: 'carouselOverlayed',
    category: 'simple',
  },
  features: {
    isHeroBannerEnabled: true,
  },
  braze: {
    apiKey: 'ed3bf3a9-e686-472b-8e5a-b674be61ac46',
    baseUrl: 'sdk.iad-01.braze.com',
  },
  postalRequestMoreInfoUrl:
    'https://legal-agreement-pdfs-dev.s3.eu-west-1.amazonaws.com/brand4/legal/sweeps-rules?x-id=GetObject&versionId=R93F5BcHhM.y5lrBg2XmPhHO1gFFDEp3&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=ASIAXYKJVWXLSJSG7WGF%2F20250404%2Feu-west-1%2Fs3%2Faws4_request&X-Amz-Date=20250404T103837Z&X-Amz-Expires=300&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEJv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEaCWV1LXdlc3QtMSJIMEYCIQCCrFUbl6lzOUw1ekq7JtOIf5VXpISdVOsO%2BSc%2F4Nxb7wIhALSxo%2BQYw5SG6GOkO5z%2F0iKICrmb5O1QWBBPNf3XyGnkKpMFCBQQABoMNTMzMjY3MzMwNTE5IgzgUfIe%2FLJsLXKuL4wq8ARzW1o8w4pMyxZgcqm2uneG4CYPtdSeXPrI0sNhNLyg2lQeGmrdojy8iPBmA6i%2BFAs%2FN%2FVPz8nRmvl4SUCGLmiMvj2sJh2%2BFKGfIgrVhEVj6F3wmEhSb8nIMJmr8wMcu5nBHxx9OUUF1xSIy2HO5PCcUSfCpzbcg1oP6txmTKFC3%2BKwOT7QaZRR0aCoWcKjJdSTIt1CZ9AyDwpA5gUis%2FzvvLpRWtNOtzt2aL8zD3q7S89u7UNH24UA8isxWS3ZGzHI0aB0nzpvN0iCqlCRP3xus3GprNDZwAAjWnxYVfqkW9e3aJFwigmyB8qJxAx4Ygqs0CQuKV3Lr%2FY4FKdU4pq5elvJfzjAxcxBJA%2BpTwr7fDdrL6gC%2BxLcY3t%2BZAzrQJyVAxupGKBeAeOFBWov3n5D19fBQ0xIHTbd29rGT%2FWIe3L75SGR58aUj2XYMP2sNWy3lv%2BsfJO1sWSvqMFjaRX6B1oqllaBPFqRUL6JD53%2BRpNfMPhcX3InBaBYe4xEp%2F5zPhRNK8e87aAPSbygJkexGKv351DbPdsgboMvJYTYfM%2FVC%2B9VLMO4p4nlQDdETVrzRZOXg8TWPE8LlJbPdIZkh62L3qTD0ouPEk7m6TQCbhjcjKl1ZuoujTjFfBZvyL4CDtu8JUIpqZlIwcKwv45IaOxtYovnTTQUMBKrLn%2BNMf1hBhJbqSjCdBSirluMZtHZ9hNw%2B3o%2FRPcTnNY7CWTggl5aA4o%2BhnY1OomYwYRX49R3Ztn13W3Mf5FD1FVQ95bdNRFsRNXxWVHeMqGDb61eu%2FYbrou4wAC2uBdO911dYkhJ8wsSEI%2FNhSVQpxNnNngwre2%2BvwY6mgGG4U1J2oJSA4yTBwOZThSnrdpJ29FNS%2BRUC7BySMNEHJl4ZoqZmdSrRxbbPHTHNSjv1XwM51Wh6Pwce6KODSAZgCGqVL8WR9X5ch%2FtD5zL2jIvgonDBp4GCCayfaYhS2xBlQ9HOsgpE9qgNdSquk5N5JB3k2fLaM%2BmSSqmhStZRDwckHVLbPuvQr1GZXSxt%2BFnT5UYxcRJ2WDs&X-Amz-SignedHeaders=host&X-Amz-Signature=cc0ca1b164127655e942788c5a1fc51ff373c9b12379fc391679384380ffa3a8',
  pamLegalDocumentsUrl: 'https://pam.dev-vgw-vanilla.com/legal',
  ageRestriction: 21,
  logo: {
    width: 22,
    height: 40,
    src: logo,
  },
  brandedAnimation: null,
  grafana: {
    isEnabled: false,
  },
  minimumRedemptionThreshold: '50.00',
}

const BRAND_CONFIGS: PerEnvironmentConfigs = {
  local: {
    ...devConfig,
  },
  dev: {
    ...devConfig,
  },
  test: {
    ...devConfig,
  },
  prod: {
    ...devConfig,
  },
}

export default BRAND_CONFIGS
